/*eslint-env browser*/
import topLeftAndPivot from "./topleft_and_pivot.js"
import screenImageUtils from "./screen_image_utils.js"
import download from "./download.js"
import canvasTo from "./canvas_to.js"
import exportMethods from "./export_methods.js"

const {tempCanvasFromImageOrCanvas, toThumbnailCanvas} = canvasTo

const {attachExportMethods} = exportMethods

const {downloadAsFile} = download

const {containsPositionParam, copyPositionParam} = topLeftAndPivot

const {getScaleAndCropParams} = screenImageUtils


let ScreenImage
let originalInit



function init (newScreenImage, newInit) {
    ScreenImage  = newScreenImage
    originalInit = newInit

    for (let name in api) {
        ScreenImage.prototype[name] = api[name]
    }

    return {importFromSource}
}



const api = {}




//************************ IMPORTS



function importFromSource (screenImage, source, params) { //eslint-disable-line complexity
    if (typeof source === "string") {
        importFromUrl(screenImage, source, params)
    } else if (source instanceof ScreenImage) {
        importFromScreenImage(screenImage, source, params)
    } else if (source instanceof HTMLImageElement) {
        importFromImage(screenImage, source, params)
    } else if (source instanceof HTMLVideoElement) {
        importFromVideo(screenImage, source, params)
    } else if (source instanceof HTMLCanvasElement) {
        importFromCanvas(screenImage, source, params)
    } else if (source instanceof ImageData) {               //the most direct
        importFromImageData(screenImage, source, params)
    } else if (source.toImageData) {
        importFromScreenSuite(screenImage, source, params)
    } else if ("cropSource" in source) { //FIXME doc    (for instance, a frame from SpriteCollection)
        let {image, cropSource, flip} = source
        params = Object.assign({cropSource, flip}, params)
        importFromSource(screenImage, image, params)
    }
}



function importFromUrl (screenImage, url, params) {
    if (url.endsWith(".mp4")) { //FIXME
        importFromVideoUrl(screenImage, url, params)
        return
    }
    const remoteImage = new Image()
    remoteImage.crossOrigin = "Anonymous"
    remoteImage.src = url
    importFromImage(screenImage, remoteImage, params)
}


function importFromVideoUrl (screenImage, url, params) {
    const remoteVideo = document.createElement("video")
    remoteVideo.crossOrigin = "Anonymous"
    remoteVideo.src = url

    screenImage.queueForAfterLoad = []

    remoteVideo.addEventListener("canplay", () => {
        remoteVideo.muted = true
        remoteVideo.width  = remoteVideo.videoWidth
        remoteVideo.height = remoteVideo.videoHeight
        remoteVideo.play()
    })

    let stopImporting
    remoteVideo.addEventListener("timeupdate", function () {
        if (stopImporting) {
            return
        }
        stopImporting = true
        importFromLoadedImage(screenImage, remoteVideo, params)
    }, false)
}



function importFromScreenImage (screenImage, source, params) {
    const {whenLoaded = () => {}} = params
    const {queueForAfterLoad} = source
    if (queueForAfterLoad) {
        screenImage.queueForAfterLoad = []
        queueForAfterLoad.push(() => importFromScreenImage(screenImage, source, params))
    } else {
        params = Object.assign({}, params)
        takeAutoParamsFromScreenImage(params, source)

        delete params.whenLoaded

        screenImage.syncFromSource = function () {
            const {imageData} = source
            importFromImageData(screenImage, imageData, params)
        }

        screenImage.syncFromSource()


        handleQueue(screenImage)
        whenLoaded(screenImage)
    }
}


function importFromImage (screenImage, image, params) {
    if (image.complete) {
        importFromLoadedImage(screenImage, image, params)
    } else {
        screenImage.queueForAfterLoad = []
        image.addEventListener("load", () => importFromLoadedImage(screenImage, image, params))
    }
}


function importFromVideo (screenImage, video, params) {
    if (video.readyState >= 1) {
        importFromLoadedImage(screenImage, video, params)
    } else {
        video.addEventListener("canplay", () => importFromLoadedImage(screenImage, video, params))
    }
}


function importFromCanvas (screenImage, canvas, params) {
    let {cropSource, whenLoaded = () => {}} = params

    const cropAndScaleParams  = getScaleAndCropParams(canvas, params, "cropSource")
    const {cropped, rescaled} = cropAndScaleParams

    screenImage.syncFromSource = function () {
        if (cropped || rescaled) {
            canvas = tempCanvasFromImageOrCanvas(canvas, cropAndScaleParams, params)
            cropSource = {}
        }

        initImageDataFromCanvas(screenImage, canvas, cropSource)
        originalInit(screenImage, params)
    }

    screenImage.syncFromSource()

    whenLoaded(screenImage)
}


function importFromImageData (screenImage, imageData, params) {
    const {whenLoaded = () => {}} = params

    let cropAndScaleParams = getScaleAndCropParams(imageData, params, "cropSource")
    const {cropped, rescaled} = cropAndScaleParams

    function syncFromSource () {
        if (cropped || rescaled) {
            const {cropSource, widthInPixels, heightInPixels} = cropAndScaleParams
            let canvas = tempCanvasFromImageData(imageData, cropSource)

            cropAndScaleParams = getScaleAndCropParams(canvas, {widthInPixels, heightInPixels}, "cropSource")
            if (cropAndScaleParams.rescaled) {
                canvas = tempCanvasFromImageOrCanvas(canvas, cropAndScaleParams, params)
            }

            initImageDataFromCanvas(screenImage, canvas)
        } else {
            screenImage.imageData = imageData
            screenImage.imageDataData = imageData.data
        }
    }

    syncFromSource()

    if (!screenImage.syncFromSource) {
        screenImage.syncFromSource = syncFromSource
    }


    originalInit(screenImage, params)
    whenLoaded(screenImage)
}


function importFromScreenSuite (screenImage, source, params) {

    const {whenLoaded = () => {}} = params
    params = Object.assign({}, params)

    takeAutoParamsFromCrop(params)
    takeAutoParamsFromCamera(params, source)

    delete params.cropSource
    delete params.whenLoaded

    screenImage.syncFromSource = function () {
        const imageData = source.toImageData(params.cropSource)
        importFromImageData(screenImage, imageData, params)
    }

    screenImage.syncFromSource()
    whenLoaded(screenImage)
}





//************************ EXPORTS


api.toCanvas = function (params = {}) {
    let canvas = tempCanvasFromImageData(this.imageData)

    const cropAndScaleParams  = getScaleAndCropParams(canvas, params, "crop")
    const {cropped, rescaled, flip} = cropAndScaleParams
    if (cropped || rescaled || flip) {
        canvas = tempCanvasFromImageOrCanvas(canvas, cropAndScaleParams, params)
    }

    return canvas
}



api.toScreenCanvas = function (params = {}) {
    const {ScreenCanvas} = ScreenImage //added by ScreenCanvas, to avoid circular dependency in requirejs
    if (!ScreenCanvas) {
        throw new Error("You should add the ScreenCanvas lib to your project to be able to export with toScreenCanvas()")
    }

    const canvas = this.toCanvas(params)
    const screenCanvas = new ScreenCanvas(canvas)
    return screenCanvas
}


api.toScreen = function (params = {}) {
    const {Screen} = ScreenImage //added by Screen, to avoid circular dependency in requirejs
    if (!Screen) {
        throw new Error("You should add the Screen lib to your project to be able to export with toScreen()")
    }

    const position = this.getPosition()
    if (!position) {
        const error = new Error(
            "This image needs a position and a size to support this method. " +
            "Example: createImage({source, center: {x: 0, y: 0}, width: 10})"
        )
        error.frLocale =
            "Cette image a besoin d'une position et d'une taille pour supporter cette méthode. " +
            "Exemple : createImage({source, center: {x: 0, y: 0}, width: 10})"
        throw error
    }

    const canvas = this.toCanvas(params)
    const screen = new Screen(canvas)
    const {center, width} = position
    screen.setCamera({
        center,
        scale: canvas.width / width
    })
    return screen
}


// toImageData, toDataURL, toImageBitmap, toBlob, toBase64, toImageElement,
// toPNGImage and download, all over toCanvas
const defaultFileName = "screen_image"

attachExportMethods(api, {
    downloadName:  "download",
    defaultName:   defaultFileName,
    messagePrefix: "image.export"
})


// this family stores its pixels as ImageData : hand it over directly when
// there is nothing to crop, rescale or flip
const convertToImageData = api.toImageData

api.toImageData = function (params) {
    if (params) {
        return convertToImageData.call(this, params)
    }
    return this.imageData
}


// how log(image) shows in terminals (rich_value.js): a curated summary
// with a lazily drawn thumbnail instead of the raw pixel internals
api.terminalDisplay = function () {
    return {
        constructorName: "Image",
        widthInPixels:   this.widthInPixels,
        heightInPixels:  this.heightInPixels,
        thumbnail:       () => toThumbnailCanvas(this.toCanvas())
    }
}



// an image that comes from a file and was never drawn on downloads its original
// bytes - no re-encoding. And a download asked for before the source finished
// loading waits for it.
const downloadTheCanvas = api.download

api.download = function (params = {}) {

    let downloadIt = () => {
        if (!this.touched && this.originalBlob && blobMatchesFormat(this.originalBlob, params)) {
            let {name = defaultFileName, fileName = name} = params
            downloadAsFile({
                name:    fileName,
                content: this.originalBlob
            })
        } else {
            downloadTheCanvas.call(this, params)
        }
    }

    if (this.queueForAfterLoad) {
        this.queueForAfterLoad.push(downloadIt)
    } else {
        downloadIt()
    }
}



api.getCompanionScreen = function () {
    if (!this.companionScreen) {
        this.companionScreen = this.toScreen()
    }
    return this.companionScreen
}


api.forToxiElement = function () {
    return this.toImageElement()
}










//************************ IMPORT TOOLS

function importFromLoadedImage (screenImage, image, params) {
    const {whenLoaded = () => {}} = params

    screenImage.syncFromSource = function () {
        if (image.originalBlob) {
            screenImage.originalBlob = image.originalBlob
        }
        const canvas = tempCanvasFromImageOrCanvas(image, getScaleAndCropParams(image, params, "cropSource"), params)
        initImageDataFromCanvas(screenImage, canvas)
        originalInit(screenImage, params)
    }

    screenImage.syncFromSource()


    handleQueue(screenImage)
    whenLoaded(screenImage)
}


function handleQueue (screenImage) {
    const {queueForAfterLoad = []} = screenImage
    delete screenImage.queueForAfterLoad
    queueForAfterLoad.forEach(callback => callback(screenImage))
}



function tempCanvasFromImageData (imageData, cropSource = {}) {
    const {width = imageData.width, height = imageData.height, topLeftX = 0, topLeftY = 0} = cropSource

    const canvas  = document.createElement("canvas")
    canvas.width  = width
    canvas.height = height
    const cx = canvas.getContext("2d")

    cx.putImageData(imageData, -topLeftX, -topLeftY)

    return canvas
}






function initImageDataFromCanvas (screenImage, canvas, cropSource = {}) {
    const cx = canvas.getContext("2d")
    const {
        topLeft = {},
        width   = canvas.width,
        height  = canvas.height
    } = cropSource

    const {x = 0, y = 0} = topLeft
    const imageData = cx.getImageData(x, y, width, height)
    screenImage.imageData     = imageData
    screenImage.imageDataData = imageData.data
}



function takeAutoParamsFromCrop (params) {
    const {cropSource} = params
    if (cropSource) {
        if (!containsPositionParam(params)) {
            copyPositionParam(cropSource, params)
        }
        takeDefaultDimensionsIfNeeded(params, cropSource)
    }
}


function takeAutoParamsFromCamera (params, source) {
    if ("getCamera" in source) {
        const cameraParams = source.getCamera()

        if (!containsPositionParam(params)) {
            params.center = cameraParams.center
        }
        takeDefaultDimensionsIfNeeded(params, cameraParams)
    }
}


function takeAutoParamsFromScreenImage (params, screenImage) {
    if (!containsPositionParam(params)) {
        copyPositionParam(screenImage, params)
    }
    takeDefaultDimensionsIfNeeded(params, screenImage)
}


const formatToMimeType = {
    png:  "image/png",
    jpg:  "image/jpeg",
    jpeg: "image/jpeg"
}

function getRequestedFormat ({format, name, fileName = name}) {
    if (format) {
        return format
    }
    if (fileName && fileName.includes(".")) {
        return fileName.split(".").pop().toLowerCase()
    }
    return undefined
}

function blobMatchesFormat (blob, params) {
    const requestedFormat = getRequestedFormat(params)
    if (!requestedFormat) {
        return true
    }
    const expectedMime = formatToMimeType[requestedFormat]
    return expectedMime ? blob.type === expectedMime : false
}


function takeDefaultDimensionsIfNeeded (params, {width, height}) {
    if (
        typeof params.width  === "undefined" &&
        typeof params.height === "undefined"
    ) {
        if (typeof width !== "undefined") {
            params.width = width
        }

        if (typeof height !== "undefined") {
            params.height = height
        }
    }
}






export default init
